module.exports = __webpack_public_path__ + "static/media/sylvester.4e9b2f1c.jpg";